<template>
  <el-form ref="form" :model="form" :inline="true" style="margin-bottom: -18px;" size="mini">
    <el-form-item>
      <el-button style="float: left" type="primary" @click="query">
        查询
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  data () {
    return {
      form: {
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  },
  created () {
    // this.query()
  }
}
</script>
